module.exports = __webpack_public_path__ + "static/column-402699d962b1d98482b3593795cfe4af.jpg";